module.exports = __webpack_public_path__ + "media/audio27.bc3e331d.mp3";